<template>
  <div>
    <table class="table table-striped w-100" style="table-layout: fixed;">
      <colgroup v-if="getVisibleColumnCount() === 10">
        <col style="width:9%" />
        <col style="width:25%" />
        <col style="width:7%" />
        <col style="width:9%" />
        <col style="width:25%" />
        <col style="width:7%" />
        <col style="width:9%" />
        <col style="width:25%" />
        <col style="width:7%" />
        <col style="width:16%" />
      </colgroup>
      <colgroup v-else>
        <col style="width:9%" />
        <col style="width:29%" />
        <col style="width:7%" />
        <col style="width:9%" />
        <col style="width:29%" />
        <col style="width:7%" />
        <col style="width:10%" />
      </colgroup>
      <thead>
        <tr style="background-color: lightslategray; color: white; text-align: center;">
          <th colspan="10" style="font-weight: normal;">Dx Coding</th>
        </tr>
        <tr style="text-align: left;">
          <th v-if="showPreDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th v-if="showPreDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Description</th>
          <th v-if="showPreDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important; border-right: 1px solid #ebeef5 !important">HCC</th>
          <th v-if="showOriginalDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th v-if="showOriginalDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Description</th>
          <th v-if="showOriginalDxCodeType()" style="border-bottom: 1px solid #ebeef5 !important; border-right: 1px solid #ebeef5 !important">HCC</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Description</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">HCC</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="getVisibleColumnCount() !== 10 && worksheet.dxs.length > 0">
          <td colspan="3" class="codeTypeHeader">
            <div>{{ showPreDxCodeType() ? worksheet.dxs[0].preDxCodeDesc : worksheet.dxs[0].codeDesc }}</div>
          </td>
          <td colspan="4" class="codeTypeHeader">
            <div>Recommended Dx Coding</div>
          </td>
        </tr>
        <tr v-if="getVisibleColumnCount() === 10 && worksheet.dxs.length > 0">
          <td colspan="3" class="codeTypeHeader">
            <div>{{ worksheet.dxs[0].preDxCodeDesc }}</div>
          </td>
          <td colspan="3" class="codeTypeHeader">
            <div>{{ worksheet.dxs[0].codeDesc }}</div>
          </td>
          <td colspan="3" class="codeTypeHeader">
            <div>Recommended Dx Coding</div>
          </td>
        </tr>
        <tr :class="{ bold: isDxRowChange(dx) }" v-for="dx in worksheet.dxs" :key="dx.dxId">
          <td v-if="showPreDxCodeType()" :class="{ 'red-font': isPreDxRedFont(dx, worksheet.dxs) }">
            {{ dx.preDx }}
          </td>
          <td v-if="showPreDxCodeType()" :class="{ 'red-font': isPreDxRedFont(dx, worksheet.dxs) }">
            {{ dx.preDxDesc }} <span v-if="dx.originalGrouperFlags" class="grouperFlags">({{ dx.originalGrouperFlags }})</span>
          </td>
          <td v-if="showPreDxCodeType()" :class="{ 'red-font': isPreDxRedFont(dx, worksheet.dxs) }" style="font-size: 13px; border-right: 1px solid #ebeef5">
            <div>{{ dx.preDxHccs }}</div>
            <div>{{ dx.preDxHccsV28 }}</div>
          </td>

          <td v-if="showOriginalDxCodeType()" :class="{ 'red-font': isOriginalRedFont(dx, worksheet.dxs) }" :style="dx.preDxDeleted ? 'text-decoration: line-through' : ''">
            {{ dx.preDxDeleted ? dx.preDx : dx.originalDx }}
          </td>
          <td v-if="showOriginalDxCodeType()" :class="{ 'red-font': isOriginalRedFont(dx, worksheet.dxs) }">
            {{ dx.preDxDeleted ? 'Delete Code' : dx.originalDescription }} <span v-if="dx.originalGrouperFlags" class="grouperFlags">({{ dx.originalGrouperFlags }})</span>
          </td>
          <td v-if="showOriginalDxCodeType()" :class="{ 'red-font': isOriginalRedFont(dx, worksheet.dxs) }" style="font-size: 13px; border-right: 1px solid #ebeef5">
            <div>{{ dx.originalHccs }}</div>
            <div>{{ dx.originalHccsV28 }}</div>
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(dx, worksheet.dxs) }" :style="dx.originalDeleted ? 'text-decoration: line-through' : ''">
            {{ dx.originalDeleted ? dx.originalDx || dx.preDx : dx.recommendedDx }}
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(dx, worksheet.dxs) }">
            {{ getDxRecommendedDescription(dx, worksheet.dxs) }} <span v-if="(dx.recommendedDx && dx.recommendedGrouperFlags) || (dx.recommendedGrouperFlags && dx.recommendedGrouperFlags !== dx.originalGrouperFlags)" class="grouperFlags">({{ dx.recommendedGrouperFlags }})</span>
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(dx, worksheet.dxs) }" style="font-size: 13px;">
            <div>{{ dx.recommendedHccs }}</div>
            <div>{{ dx.recommendedHccsV28 }}</div>
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(dx, worksheet.dxs) }">{{ dx.reasonForChange }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'ProWorksheet',
    // props: ['worksheet', 'isCoder', 'optionalParameters'],
    props: {
      worksheet: {
        type: Object
      },
      isCoder: {
        type: Boolean
      },
      codeTypesParam: {
        type: Array,
        default: function() {
          return []
        }
      },
      optionalParameters: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    components: {},
    data() {
      return {}
    },
    methods: {
      showPreDxCodeType() {
        if (this.worksheet.dxs.length > 0 && this.codeTypesParam.length > 0) {
          return this.codeTypesParam.includes(this.worksheet.dxs[0].preDxCodeType)
        }
        return true
      },
      showOriginalDxCodeType() {
        if (this.worksheet.dxs.length > 0 && this.codeTypesParam.length > 0) {
          return this.codeTypesParam.includes(this.worksheet.dxs[0].codeType)
        }
        return true
      },
      isDxRowChange(dx) {
        if (dx.recommendedDx || dx.originalDeleted) {
          return true
        }

        if (((this.codeTypesParam.length > 0 && this.codeTypesParam.includes(dx.preDxCodeType)) || this.codeTypesParam.length === 0) && (dx.preDxDeleted || dx.originalDx)) {
          return true
        }

        return false
      },
      getDxRecommendedDescription(dx, dxs) {
        if (dx.originalDeleted) {
          if (dx.recommendedDesc) {
            return `Delete Diagnosis - ${dx.recommendedDesc}`
          }
          return 'Delete Diagnosis'
        }

        if (dx.recommendedDesc && dx.rowNumber === 1 && dxs.some(x => x.newPrimary)) {
          if (dx.recommendedDesc) {
            return `Resequence Principal Diagnosis - ${dx.recommendedDesc}`
          }
          return 'Resequence Principal Diagnosis'
        }

        return dx.recommendedDesc
      },
      getCptDeletedDescription(cpt) {
        if (cpt.origDesc) {
          return `Delete CPT - ${cpt.origDesc}`
        }
        return 'Delete CPT'
      },
      isPreDxRedFont(dx, dxs) {
        if (dx.preDxDeleted || (dx.originalDeleted && !dx.originalDx)) {
          return true
        }
        return false
      },
      isOriginalRedFont(dx) {
        if (dx.originalDeleted || dx.preDxDeleted) {
          return true
        }
        return false
      },
      isRecommendedRedFont(dx) {
        return dx.originalDeleted || dx.preDxDeleted
      },
      getVisibleColumnCount() {
        let count = 0
        if (this.showPreDxCodeType()) {
          count += 3 // pre-dx, pre-description, pre-hcc
        }
        if (this.showOriginalDxCodeType()) {
          count += 3 // orig-dx, orig-description, orig-hcc
        }
        count += 4 // rec-dx, rec-description, rec-hcc, reason-for-change
        return count
      }
    }
  }
</script>

<style scoped>
  .red-font {
    color: red;
  }

  .bold {
    font-weight: bold;
  }

  .codeTypeHeader {
    text-align: left;
    padding: 4px 0px 4px 5px;
    border-left: 8px solid #3378aa7c;
    font-style: italic;
  }
</style>
